import React, { type FC } from 'react'

import { GRID_VARIANT_SMALL, Grid, GridCell } from 'mailup-web-components'

import InputCritType from 'Pages/RecipientsList/components/filters/InputCritType'

import InputOptoutMessage from 'Pages/RecipientsList/components/filters/optout/InputOptoutMessage'

import ActionDeleteCriterion from 'Pages/RecipientsList/components/filters/ActionDeleteCriterion'

interface CriterionOptoutMessageProps {
  index: number
}

const CriterionOptoutMessage: FC<CriterionOptoutMessageProps> = ({ index }) => {
  return (
    <Grid variant={GRID_VARIANT_SMALL} cols={12}>
      <GridCell span={3}>
        <InputCritType index={index} />
      </GridCell>
      <GridCell span={6}>
        <InputOptoutMessage index={index} />
      </GridCell>
      <GridCell span={1}>
        <ActionDeleteCriterion index={index} />
      </GridCell>
    </Grid>
  )
}

export default CriterionOptoutMessage
